<kt-splash-screen *ngIf="loader"></kt-splash-screen>
<router-outlet></router-outlet>
<!-- FOR TESTING PURPOSES ONLY FOR LLS SCAN -->